import { render } from "./WeekpartColumnChart.vue?vue&type=template&id=55e298d2"
import script from "./WeekpartColumnChart.vue?vue&type=script&lang=js"
export * from "./WeekpartColumnChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/customer-interface-v3/customer-interface-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__